export default "__VITE_ASSET__DBnxngz5__"